import React, { useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleTheme } from '@reducers/theme';
import cn from 'classnames';
import styles from './loader.module.css';
import { safeJsonParse } from '@utility/helperFunction';

const getTheme = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem('auth'))?.serverAppTheme;
  } catch {
    return null;
  }
};

const Loader = memo(({ noTransparent, notFixed, message }) => {
  const serverAppTheme = useSelector(state => state.theme.serverAppTheme);
  const dispatch = useDispatch();
  const isPortrait = window.innerHeight > window.innerWidth;
  const themeChange = safeJsonParse(window.sessionStorage.getItem("auth"), {});

  useEffect(() => {
    const theme = getTheme();
    if (theme) {
      dispatch(toggleTheme(theme));
    }
  }, [dispatch]);

  const containerClasses = cn(
    'mx-sm-0',
    noTransparent ? '' : styles.transparent,
    notFixed && `${styles.fixed} top-0 start-0 w-100 h-100 col-12 mx-0 px-0`
  );

  const innerClasses = cn(
    'row page mx-0',
    (notFixed || !noTransparent) && 'h-100 w-100',
    'justify-content-center align-items-center'
  );

  const messageStyle = message
    ? {
        color: serverAppTheme?.primary_text,
      }
    : {
        color: `${
          themeChange?.serverAppTheme === '1'
            ? 'rgb(255,255,255)'
            : 'rgb(0,0,0)'
        }`,
      };

  return (
    <div className={containerClasses}>
      <div className={innerClasses}>
        <div className={styles.loaderContainer}>
          <div className={styles.loader}>
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                className={styles.bar}
                style={{
                  transform: `rotate(${i * 30}deg)`,
                  animationDelay: `${i * 0.1}s`,
                }}
              />
            ))}
          </div>
        </div>
        <div
          className={cn(
            'fw-600 fs-16 position-fixed',
            styles.message,
            isPortrait ? styles.loadingMsgPosition : styles.messagePosition
          )}
          style={messageStyle}
        >
          {message ? message : 'Loading...'}
        </div>
      </div>
    </div>
  );
});

Loader.displayName = 'Loader';

export default Loader;
